import { FC, useState, useEffect } from "react"
import { IProfileContractModel } from "../../core/_models"
import { useIntl } from "react-intl";
import SharedData from "../../../common/SharedData"
import { getDeliveryDurations, updateSupplierInfo } from "../../core/_requests"

const ContractStockTable:FC<IProfileContractModel> = ({delivery_duration_id,delivery_duration_name,open_friday,open_saturday}) => {
  const {formatMessage} = useIntl();
  const {currentUser, language} = SharedData();

  const [friday, setFriday] = useState(Number(open_friday) ? 1 : 0)
  const [saturday, setSaturday] = useState(Number(open_saturday) ? 1 : 0)

  const [durations, setDurations] = useState<Array<{delivery_duration_id:number; name:string}>>([])
  const [selectedId, setSelectedId] = useState<string>(delivery_duration_id != null ? String(delivery_duration_id) : '')

  useEffect(() => {
    (async () => {
      const {data} = await getDeliveryDurations(currentUser?.token, language)
      setDurations(data.durations || [])
    })()
  }, [])

  useEffect(() => {
        const id = delivery_duration_id != null
          ? String(delivery_duration_id)
          : (durations.find(d => d.name === delivery_duration_name)?.delivery_duration_id != null
              ? String(durations.find(d => d.name === delivery_duration_name)!.delivery_duration_id)
              : '')
        setSelectedId(id)
  }, [delivery_duration_id, delivery_duration_name, durations])

  const saveDuration = async (id: number) => {
    await updateSupplierInfo(currentUser?.token, language, { delivery_duration_id: id })
    setSelectedId(String(id))
  }

  const save = async (patch: any) => {
    await updateSupplierInfo(currentUser?.token, language, patch)
  }
  return (
    <div className='col-sm-12'>
      <label className='text-gray-600 fw-bold fs-5 d-block mb-5'>{formatMessage({ id: "stock_delivery_lbl" })}</label>
      
        {/* begin::Table */}
        <table className='table align-middle gs-0 gy-5 border-top mt-2'>
          {/* begin::Table body */}
          <tbody>
          <tr className='border-bottom'>
            <th className='fs-5 w-50 fw-bold px-sm-4 text-gray-600'>{formatMessage({ id: "lead_time_lbl" })}</th>
            <th colSpan={2} className='fs-5 fw-bold px-sm-4 text-center text-gray-600 text-nowrap'>{formatMessage({ id: "bsns_days_lbl" })}</th>
            <th className='fs-5 fw-bold px-sm-4 text-center text-nowrap'>
              <select
                className='form-select form-select-sm w-auto d-inline-block'
                value={selectedId}
                onChange={async (e) => await saveDuration(Number(e.target.value))}
              >
                {selectedId === '' && (
                  <option value='' disabled>{delivery_duration_name || formatMessage({id:'select'})}</option>
                    )}
                {[...durations]
                  // Order by the number of business days (the API returns them unsorted, so "10"
                  // could appear before "2"). Fall back to id when a name has no leading number.
                  .sort((a, b) => (parseInt(a.name, 10) || a.delivery_duration_id) - (parseInt(b.name, 10) || b.delivery_duration_id))
                  .map(d => (
                    <option key={d.delivery_duration_id} value={String(d.delivery_duration_id)}>{d.name}</option>
                  ))}
              </select>
            </th>
          </tr>
            <tr className='border-bottom'>
              <th className='fs-5 w-50 fw-bold px-sm-4 text-gray-600'>{formatMessage({ id: "open_friday_lbl" })}</th>
              <th colSpan={2} className='fs-5 fw-bold px-sm-4 text-center text-gray-600 text-nowrap'></th>
              <th className='fs-5 fw-bold px-sm-4 text-center text-nowrap'>
                <select
                  className='form-select form-select-sm w-auto d-inline-block'
                  value={friday}
                  onChange={async (e) => {
                    const v = Number(e.target.value)
                    setFriday(v)
                    await save({ open_friday: v })
                  }}
                >
                  <option value={1}>{formatMessage({id: 'open_value'})}</option>
                  <option value={0}>{formatMessage({id: 'closed_value'})}</option>
                </select>
              </th>
            </tr>
            <tr className='border-bottom'>
              <th className='fs-5 w-50 fw-bold px-sm-4 text-gray-600'>{formatMessage({ id: "open_saturday_lbl" })}</th>
              <th colSpan={2} className='fs-5 fw-bold px-sm-4 text-center text-gray-600 text-nowrap'></th>
              <th className='fs-5 fw-bold px-sm-4 text-center text-nowrap'>
                <select
                  className='form-select form-select-sm w-auto d-inline-block'
                  value={saturday}
                  onChange={async (e) => {
                    const v = Number(e.target.value)
                    setSaturday(v)
                    await save({ open_saturday: v })
                  }}
                >
                  <option value={1}>{formatMessage({id: 'open_value'})}</option>
                  <option value={0}>{formatMessage({id: 'closed_value'})}</option>
                </select>
              </th>
            </tr>
          </tbody>
          {/* end::Table body */}
        </table>
        {/* end::Table */}
      {/* end::Table Container */}
    </div>
  )
}

export default ContractStockTable
